import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import {Location} from '@angular/common';
import { Program } from '../../interfaces/program.model';
import { ProgramService } from 'app/services/program.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-title-header',
  templateUrl: './title-header.component.html',
  styleUrls: ['./title-header.component.scss']
})
export class TitleHeaderComponent implements OnInit, AfterViewInit {
  @Input() program: Program;
  @Input() title: string;
  @Input() color: number;
  @Input() crumbs: any[];
  @Input() data: any[] = [];
  programs: Program[];

  constructor(
    private location: Location,
    private _programService: ProgramService,
    private router: Router,
    ) { }

  ngOnInit() {
    // console.log(this.program);
    if (this.crumbs) {

      this._programService.get()
        .subscribe(data => this.programs = data.map(item => ({
          name: item.naam,
          id: item.id,
          number: item.volgorde
      })));
    }
  }

  ngAfterViewInit() {

  }

  setProgram(item) {
    this.router.navigate(['/', 'programma', item.target.value]);
  }

  historyBack() {
    // console.log(this.crumbs.length);
    // this.location.back();

    if (this.crumbs.length < 2) {
      this.router.navigate(['/']);
    } else {
      this.router.navigate([this.crumbs[0].link]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/title-header/title-header.component.ts